class SP_PromoBar extends HTMLElement {
  SWIPE_SECONDS = 5;
  selectors = {
      active: 'promo-bar--active',
      textContainer: '.promo-bar--text-container',
      sectionId: '#section-id-TBD',
      actionBtns: '.promo-bar--action',
      entriesContainer: '.promo-bar--announcements',
      countrySelector: '.promo-bar--country-selector',
      countryActive: '.promo-bar--country-selector .active-store-text',
      countryOptions: '.promo-bar--country-selector .country-options'
  }

  isCustomizer = false
  settings = null
  swipeInterval = null
  elements = {}

  constructor() {
      super()
      this.init()
  }

  collectItems() {
      this.settings = JSON.parse(this.dataset.settings)
      this.SWIPE_SECONDS = Number(this.settings.swipeSeconds)
      this.selectors.sectionId = `#${this.id}`
      this.isCustomizer = window.top.location.href.includes('/editor')

      this.elements.parentContainer = this.parentElement
      this.elements.announcementsContainer = this.querySelector(this.selectors.entriesContainer)
      this.elements.actionBtns = [...this.querySelectorAll(this.selectors.actionBtns)]
      this.elements.announcements = [...this.querySelectorAll(this.selectors.textContainer)]
  }

  getActiveElemInfo() {
      const activeTextElem = this.elements.announcements.find( elem => elem.classList.contains(this.selectors.active) )
      const activeTextIndex = this.elements.announcements.findIndex( elem => elem.classList.contains(this.selectors.active) )

      return {
          index: activeTextIndex,
          element: activeTextElem
      }
  }

  setNewActiveByIndex( oldIndex, newIndex ) {
      this.elements.announcements[oldIndex].classList.remove(this.selectors.active)
      this.elements.announcements[newIndex].classList.add(this.selectors.active)
  }

  createInterval({ reInit } = { reInit: false }) {
      reInit && clearInterval(this.swipeInterval)

      this.swipeInterval = setInterval(() => {
          const { index, element } = this.getActiveElemInfo()
          if ( !!!element ) return

          const nextIndex = index === (this.elements.announcements.length - 1) ? 0 : index + 1
          this.setNewActiveByIndex( index, nextIndex )
      }, this.SWIPE_SECONDS * 1000);
  }

  actionBtnClickHandler({ target }) {
      target = target.closest(this.selectors.actionBtns)
      const { index } = this.getActiveElemInfo()
      let newIndex

      if ( target.classList.contains('left') ) {
          newIndex = index === 0 ? this.elements.announcements.length - 1 : index - 1
      } else {
          newIndex = index === (this.elements.announcements.length - 1) ? 0 : index + 1
      }

      this.setNewActiveByIndex( index, newIndex )
      this.createInterval({ reInit: true })
  }

  countrySelectorBtnHandler({ target }) {
      this.elements.countrySelectorContainer.classList.toggle('opened')
  }

  async setSmartWidth( evt ) {
      this.isCustomizer && await (() => new Promise((res, _) => setTimeout(res, 75)))()
      if ( window.innerWidth >= 720 ) {
          this.classList.remove('initialized')
          this.elements.announcementsContainer.style.width = 'auto'
          const contentWidths = this.elements.announcements.map( x => x.clientWidth )
          let maxWidth = Math.max(...contentWidths)
          if ( window.innerWidth < 970 && maxWidth > 520 ) maxWidth = 520
          this.elements.announcementsContainer.style.width = !!maxWidth ? `${maxWidth}px` : 'auto'
          this.classList.add('initialized')
      } else {
          this.elements.announcementsContainer.style.width = '100%'
      }
  }

  async setListeners() {
      if ( this.settings.promoTextCount > 1 ) {
          this.elements.actionBtns.forEach( btn => {
              btn.addEventListener('click', this.actionBtnClickHandler.bind(this))
          })
      }

      this.setSmartWidth()
      window.addEventListener('resize', this.setSmartWidth.bind(this))
  }

  async init() {
      this.collectItems()
      await this.setListeners()

      this.settings.promoTextCount > 1 && this.createInterval()
      this.classList.add('initialized')
  }
}

customElements.define('promo-bar', SP_PromoBar);
